import { parseSiteConfigData } from './siteSeo.js'
import { getViewportWidthByUserAgent } from './ssrDevice.js'

const DESKTOP_VIEWPORT_WIDTH = 1200
const PREVIEW_PATH_PATTERN = /^\/preview(?:\/|$)/

function normalizeBoolean(value) {
  if (value === true || value === 1)
    return true
  if (value === false || value === 0 || value === undefined || value === null)
    return false

  return String(value).trim().toLowerCase() === 'true'
}

export function isDesktopUserAgent(userAgent) {
  return getViewportWidthByUserAgent(userAgent) >= DESKTOP_VIEWPORT_WIDTH
}

export function shouldBypassDesktopAccessBlock(requestPath) {
  return PREVIEW_PATH_PATTERN.test(String(requestPath || '').split('?')[0])
}

export function shouldBlockDesktopAccess(input, userAgent, requestPath = '') {
  if (shouldBypassDesktopAccessBlock(requestPath))
    return false

  const configData = input && input.configData !== undefined
    ? parseSiteConfigData(input.configData)
    : parseSiteConfigData(input)

  return normalizeBoolean(configData.disablePcAccess) && isDesktopUserAgent(userAgent)
}
